
import React from 'react';
import { Filter } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';

interface FilterButtonProps {
  isActive: boolean;
  hasFilters: boolean;
  onClick: () => void;
  className?: string;
  variant?: "ghost" | "outline" | "default" | "destructive" | "secondary" | "link" | null | undefined;
}

const FilterButton: React.FC<FilterButtonProps> = ({
  isActive,
  hasFilters,
  onClick,
  className = "",
  variant = "ghost"
}) => {
  return (
    <Button 
      variant={isActive ? "outline" : variant}
      size="icon" 
      className={`h-8 w-8 rounded-full relative ${className}`}
      onClick={onClick}
    >
      <Filter size={20} className={isActive ? "text-brand-green" : "text-gray-600"} />
      {hasFilters && (
        <Badge 
          className="absolute -top-1 -right-1 h-4 w-4 p-0 flex items-center justify-center bg-brand-green text-white text-[10px] border-2 border-white"
          variant="default"
        />
      )}
    </Button>
  );
};

export default FilterButton;
